import axios from 'axios'
import {apiToTransaction, apiToPortfolio} from '@/services/converters'

const API_V1_URL = process.env.API_V1_URL

export default {
  getPortfolioDetails(portfolioId) {
    return axios.get(API_V1_URL + '/portfolio/' + portfolioId)
      .then(res => apiToPortfolio(res.data))
      .catch(errObj => Promise.reject(errObj.error))
  },
  getPortfolioTransactions(portfolioId, offset = 0, limit = 20) {
    return axios.get(API_V1_URL + '/portfolio/' + portfolioId + '/tx?offset=' + offset + '&limit=' + limit)
      .then(res => {
        return {
          transactions: res.data.map(apiToTransaction),
          total: res.count,
        }
      })
      .catch(errObj => Promise.reject(errObj.error))
  },
}



// WEBPACK FOOTER //
// ./src/services/portfolioService.js